module.exports = __webpack_public_path__ + "static/media/avatar6.a3c20a36.jpg";